// React imports
import React from "react"

// Project Imports
import PremiumAndRiderAmountComponent from "modules/optimization/components/premium-and-rider-amount-component/PremiumAndRiderAmountComponent"
import SolutionScreenLADetails from "../solution-screen-LA-details/SolutionScreenLADetails"
import ProductConstants from "constants/ProductConstants"

const LaAndPremiumRiderComponent = (props) => {


  const {
    percentValue,
    LaName,
    productName,
    totalPremiumAmount,
    totalAmountReceivable,
    nudgeMessage,
    CardName
  } = props

  return (
    <div>

     <div className="border-top t-2">
      <SolutionScreenLADetails
        LaName={LaName}
        ProductName={productName}
        amount={totalPremiumAmount}
        percentValue={percentValue}
        totalAmountReceivable={totalAmountReceivable}
        nudge_message={nudgeMessage}
        CardName={CardName}
      />
     </div>
    </div>
  )
}

export default LaAndPremiumRiderComponent
